import {AfterViewInit, Component, OnInit, ViewChild, Input, OnDestroy} from '@angular/core';
import * as _ from 'lodash';
import * as Player from '@vimeo/player/dist/player.js';
import { MethodsService } from 'src/app/services/methods.service';
import { CommonsService } from 'src/app/services/common.service';
import { InteractionsService } from 'src/app/services/interactions.service';

@Component({
  selector: 'app-memory',
  templateUrl: './memory.component.html',
  styleUrls: ['./memory.component.scss']
})
export class MemoryComponent implements OnInit, OnDestroy {

  @Input('interactionId') interactionId;

  @ViewChild('player_container') playerContainer;
  private player: Player;

  flipped;
  twoCards = false;
  selectedCards = [];
  guessedCards = [];
  completed = 0;
  checking = false;
  language;

  activatedInteractionId;
  interactionActive;
  gameData;

  private interaction;
  private interactionsSubscriber;

  constructor(
    public methods: MethodsService,
    public common: CommonsService,
    private interactionsService: InteractionsService
  ) {
    this.common.setHeader('interaction');
    this.language = localStorage.getItem('l')
  }

  ngOnInit() {
    this.interactionsSubscriber = this.interactionsService.interactions$.subscribe(interactions => {
      this.interaction = interactions.filter(interaction => interaction.id === this.interactionId)[0];
      this.methods.get('assets/data/' +this.language +'/' + this.interaction.content.configId + '.config.json').subscribe( config => {
        this.gameData = config;
        if (this.interaction.completed.onComplete) {
          this.flipAllCards();
        }
      });
    });
  }

  addToArray(value, i) {
    console.log('1.1 - add to array');
    this.selectedCards.push({value: value, index: i});
    console.log('1.2 - add to array');
  }

  flipCard(i) {
    this.gameData[i].flipped = true;
  }

  flip(e, value, i) {

    if (_.indexOf(this.guessedCards, i) > -1 || (this.selectedCards.length > 0 && this.selectedCards[0].index === i)) {
    } else if (!this.checking) { // se non è già stata indovinata
      if (!this.twoCards) {
        // aggiungo la carta all'array per il controllo
        this.addToArray(value, i);
        // aggiungo la classe per far girare la carta
        this.flipCard(i);
      }
      // se ho due carte nell'array controllo se sono giuste
      if (this.selectedCards.length === 2) {
        this.twoCards = true;
        this.checkCards(this.selectedCards);
      }
    }
  }

  flipAllCards() {
    for (let i = 0; i < this.gameData.length; i++) {
      this.flipCard(i);
    }
  }

  checkCards(selectedCards) {
    this.checking = true;
    if (selectedCards[0].value === selectedCards[1].value) {
      this.guessedCards.push(selectedCards[0].index, selectedCards[1].index);
      this.completed++;
      this.selectedCards = [];
      this.twoCards = false;
      this.checking = false;
      if (this.completed === 8) {
        this.interaction.completed = {
          onComplete: true,
          status: 'success'
        };
        this.interactionsService.setCompleted(this.interaction);
        this.interactionsService.updateInteraction(this.interaction);
        this.flipAllCards();
      }

    } else {
      setTimeout(() => {
        this.gameData[selectedCards[0].index].flipped = false;
        this.gameData[selectedCards[1].index].flipped = false;
        this.selectedCards = [];
        this.twoCards = false;
        this.checking = false;
      }, 1000);

    }
  }

  ngOnDestroy() {
    this.interactionsSubscriber.unsubscribe();
  }

}
